import {useState, useRef} from 'react';
import Paginacion from '../../components/helpers/Paginacion';
import { SistemaColor, SistemaTexto } from "../../components/helpers/Sistema"
import Addons from "../../components/helpers/Addons";
import dayjs from "dayjs";
import es from "dayjs/locale/es";
import 'rsuite/Toggle/styles/index.css';
import TitleTooltip from "../../components/helpers/TitleTooltip";
import Estados from "./componentes/Estados";
import RegistrarPago from "./componentes/RegistrarPago";
import PromesaPago from "./componentes/PromesaPago";
import OnOff from "./componentes/OnOff";
import AclRequired from "../../components/acl/AclRequired";
/**
 * COMPONENTE PRINCIPAL
 * @param contratos Contratos relacionados con la búsqueda
 * @param setContratos
 * @param handleAddTab Función para abrir el perfíl de datos del contrato
 * @returns {JSX.Element}
 * @constructor
 */
export default function TablaContratos({
    contratos,
    handleAddTab,
}) {
    /**
     * Librería para manejar fechas
     */
    dayjs.locale(es);
    /**
     * Obtener medidas del encabezado de la tabla
     * @type {React.MutableRefObject<null>}
     */
    const theadRef = useRef(null);
    /**
     * @param c.id_contrato
     * @type {*[]}
     */
    const listOptions = [contratos.id_contrato];
    //contratos && contratos.map((c) => listOptions.push(c.id_contrato));
    /**
     * Guardar contratos seleccionado
     */
    const [selected, setSelected] = useState([]);
    /**
     * @function handleSelect
     * @param value booleano ( depende de si es seleccionado )
     * @param name id_contrato
     */
    const handleSelect = (value, name) => {
        if (value){
            setSelected([...selected, name]);
        } else {
            setSelected(selected.filter((item) => item !== name));
        }
    };

    /**
     * @function selectAll Seleccionar todos los contratos
     * @param value id_contrato
     */
    function selectAll(value) {
        if (value){
            setSelected(listOptions);
        } else{
            setSelected([]);
        }
    }
    /**
     * Informacion básica del contrato
     * @param c.costo
     * @param c.hasta
     * @param c.activo
     * @param c.tiempo
     * @param c.estados
     * @param c.promotor
     * @param c.cotejado
     * @param c.addons
     * @param c.promesa
     * */

    return (
        <>
            <div className={"table-responsive"}>
                {
                    /**
                     * INICIA : Tabla de contratos
                     */
                }
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                    <thead ref={theadRef}>
                        <tr className="fw-bold text-muted">
                            <th className="pb-5">
                                <Checkbox name={"all"} value={selected.length === listOptions.length}
                                          updateValue={selectAll}></Checkbox>
                            </th>
                            <th colSpan={3}></th>
                            <th className="pb-5 min-w-175px">SISTEMA</th>
                            <th className="pb-5 min-w-150px">VENCE</th>
                            <th className="pb-5 min-w-150px">ESTADOS</th>
                            <th className="pb-5 min-w-150px">COMPLEMENTOS</th>
                            <th className="pb-5 min-w-150px text-end pe-4"></th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        (contratos && Array.isArray(contratos)) && contratos.map((c) => {
                            return (
                                <tr key={c.id_contrato}>
                                    {
                                        /**
                                         * INICIA : Contenido de cada contrato
                                         */
                                    }
                                    <td>
                                        <Checkbox name={c.id_contrato}
                                                  value={selected.includes(c.id_contrato)}
                                                  updateValue={handleSelect}
                                        ></Checkbox>
                                    </td>
                                    <td>
                                        <TitleTooltip title={c.vigente ? 'Activo' : 'Desactivado'} placement={'top'}>
                                            <span className={"bullet bullet-vertical h-40px bg-" + (c.vigente ? 'success' : 'danger')}></span>
                                        </TitleTooltip>
                                    </td>
                                    <td>
                                        <TitleTooltip title={`Promotor: ${c.promotor.usuario}`} placement={'top'}>
                                            <div className="symbol symbol-35px">
                                              <span className={"symbol-label fs-4 " + c.promotor.avatar}>
                                                  {c.promotor.avatar}
                                              </span>
                                            </div>
                                        </TitleTooltip>
                                    </td>
                                    <td className="w-100">
                                        <div className="d-flex text-nowrap overflow-hidden fs-6">
                                            <div className="d-block flex-column">
                                                <button type={'button'}
                                                    onClick={() => handleAddTab(c.id_contrato, c.id_cliente, c.cliente.cliente)} //(abrir tabs de contratos)
                                                    style={{userSelect: "text"}}
                                                    className="btn btn-link p-0 text-start text-uppercase text-gray-900 text-hover-primary fw-semibold">
                                                    {c.cliente.cliente}
                                                </button>
                                                <div className="d-flex text-muted">
                                                    <i className="ki-solid ki-profile-user fs-4 me-2"></i>
                                                    {
                                                        (c.usuarios && c.usuarios.length > 0) && c.usuarios.map((usuario, index) => {
                                                           return  index + 1 === c.usuarios.length ? `${usuario.usuario} ` :  `${usuario.usuario}, `;
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div className="ms-n1 me-2">
                                                <SistemaColor sistema={c.paquete.sistema}></SistemaColor>
                                            </div>
                                            <div className="d-flex flex-column fs-6">
                                                <SistemaTexto sistema={c.paquete.sistema}></SistemaTexto>
                                                <div className="d-block font-monospace">{c.paquete.paquete}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="d-flex flex-column">
                                            <div className="d-flex flex-stack ">
                                                <span className="d-block fs-6 fw-semibold text-capitalize">
                                                    {dayjs(c.hasta).format('MMM. DD, YYYY')}
                                                </span>
                                            </div>
                                            <div>
                                                <span className={"d-block fs-6 fw-bold " + ( c.cotejado === 1 ? 'text-success' : 'text-danger' ) }>
                                                    $ {c.costo}.00 MXN
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <Estados estados={c.estados}></Estados>
                                    </td>
                                    <td>
                                        {
                                           (c.addons && c.addons.complementos) && <Addons complementos={c.addons.complementos}></Addons>
                                        }
                                    </td>
                                    <td className="d-flex text-end align-items-center border-0 justify-content-end pe-4">
                                        {
                                            c.blacklist === 0 ? (
                                                <>
                                                    {
                                                        c.promesa === 1 ? (
                                                            <PromesaPago contrato={c}></PromesaPago>
                                                        ) : (
                                                            <AclRequired flag={true} allowedRoles={["ADMIN","ATN-CLIENTES"]}>
                                                                <PromesaPago contrato={c}></PromesaPago>
                                                            </AclRequired>
                                                        )
                                                    }

                                                    <RegistrarPago contrato={c} typeB={true}></RegistrarPago>

                                                    <AclRequired flag={true} allowedRoles={["ADMIN","ATN-CLIENTES"]}>
                                                        <OnOff contrato={c}></OnOff>
                                                    </AclRequired>
                                                </>
                                            ) : c.blacklist === 1 ? (
                                                <TitleTooltip title={'La última actividad del contrato ocurrió hace menos de un año'} placement={'top'}>
                                                    <div className={'d-flex w-100 justify-content-center my-3'}>
                                                        <span className="badge badge-dark fs-6 text-uppercase">Inhabilitado</span>
                                                    </div>
                                                </TitleTooltip>
                                            ) : (
                                                <TitleTooltip title={'El contrato lleva inactivo más de un año'} placement={'top'}>
                                                    <div className={'d-flex w-100 justify-content-center my-3'}>
                                                        <span className="badge badge-danger fs-6 text-uppercase">Inhabilitado</span>
                                                    </div>
                                                </TitleTooltip>
                                            )
                                        }
                                    </td>
                                    {
                                        /**
                                         * FIN : Contenido de cada contrato
                                         */
                                    }
                                </tr>
                             )
                         })
                     }
                    </tbody>
                </table>
                {
                    /**
                     * FIN : Tabla de contratos
                     */
                }
            </div>
            <div className="separator separator-dashed mb-4 mt-n4"></div>
            <Paginacion></Paginacion>
        </>
    );
}

/**
 * COMPONENTE : CHECKBOX
 * @param name
 * @param value
 * @param updateValue
 * @returns {JSX.Element}
 * @constructor
 */
export function Checkbox({
    name,
    value,
    updateValue
}) {
    /**
     * @function handleChange
     */
    const handleChange = () => {
        updateValue(!value, name);
    }
    return (
        <div className="form-check form-check-sm form-check-custom form-check-solid ms-2">
            <input className="form-check-input" type="checkbox" name={`${name}-checkbox`} checked={value} onChange={handleChange}/>
        </div>
    );
}
